import { createContext, useContext } from 'react';

import { FILTRO_INICIAL } from '../reducer';

const startOfDay = new Date();
startOfDay.setUTCHours(0, 0, 0, 0);

const endOfDay = new Date();
endOfDay.setUTCHours(23, 59, 59, 999);

const FiltroContextType = {
  filtro: { ...FILTRO_INICIAL },
  setDatePicker: () => {},
  setFiltroAmanha: () => {},
  setFiltroHoje: () => {},
  setFiltroOntem: () => {},
  setFieldDrawer: () => {},
  clearFiltro: () => {},
  fetchFiltro: () => {},
};

export const FiltroContext = createContext(FiltroContextType);

export function useFiltro() {
  return useContext(FiltroContext);
}
